export const isInCMS = () => window.hsVars !== undefined;